class MenuRistorante {

    windowWidth;

    constructor() {
        console.log('menu ristorante js class initialized')
        this.events()
    }

    events() {
        document.addEventListener("DOMContentLoaded", e => this.inizializeObj());
    }

    inizializeObj() {
        if (document.querySelector(".menu_categorie") !== null) {
            const voci_categorie = document.querySelectorAll('.voce_categoria');
            if(voci_categorie.length > 0) {
                voci_categorie.forEach(voce => {
                    voce.addEventListener("click", e => this.voceMenuClickHandler(e)); 
                });
            }

            const voci_accordion = document.querySelectorAll('.categoria_menu');
            if(voci_accordion.length > 0) {
                voci_accordion.forEach(voce => {
                    voce.addEventListener("click", e => this.voceAccordionClickHandler(e)); 
                });
            }
        }
    }

    voceMenuClickHandler(e) {
        const voceMenu = e.target.getAttribute('data-term')
        const targetMenu = document.querySelector('[data-categoria='+voceMenu+']')
        console.log(voceMenu, targetMenu);

        const voci_accordion = document.querySelectorAll('.categoria_menu');
        if (voci_accordion.length > 0) {
            voci_accordion.forEach(voce => {
                const targetParent = targetMenu.closest('div');
                if (targetParent !== voce) {
                    voce.classList.remove('active');
                    voce.querySelector('.elenco_pietanze').classList.remove('active');
                }
            });
        }

        targetMenu.closest('div').classList.toggle('active');
        targetMenu.closest('div').querySelector('.elenco_pietanze').classList.toggle('active');

        targetMenu.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        
    }

    voceAccordionClickHandler(e) {
        this.windowWidth = document.documentElement.clientWidth;
        if (this.windowWidth > 991) return;

        console.log(e.target);

        const voci_accordion = document.querySelectorAll('.categoria_menu');
        if (voci_accordion.length > 0) {
            voci_accordion.forEach(voce => {
                const targetParent = e.target.closest('div');
                if (targetParent !== voce) {
                    voce.classList.remove('active');
                    voce.querySelector('.elenco_pietanze').classList.remove('active');
                }
            });
        }

        e.target.closest('div').classList.toggle('active');
        e.target.closest('div').querySelector('.elenco_pietanze').classList.toggle('active');
    }

}

export default MenuRistorante;